import { matchText } from 'modules/core/lib/stringUtils'

class QuestionGroupActor {
  id: number
  _fullName: string
  _firstName: string
  avatar: string
  jobTitle: string

  constructor(id: number, fullName: string, firstName: string, avatar: string, jobTitle: string) {
    this.id = id
    this._fullName = fullName
    this._firstName = firstName
    this.avatar = avatar
    this.jobTitle = jobTitle
  }

  matchesFullName(search: string): boolean {
    return matchText(search, this.fullName())
  }

  fullName(): string {
    return this._fullName
  }

  firstName(): string {
    return this._firstName
  }
}

export default QuestionGroupActor
